import { Component, type ErrorInfo, type ReactNode } from 'react'
import { isChunkError, reloadOnce } from '../reload'

/** Instead of a white screen: a short message with Reload (see shared/reload.ts). Reset by changing `key`. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Screen failed:', error, info.componentStack)
    if (isChunkError(error)) reloadOnce()
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    const update = isChunkError(error)
    return (
      <div style={{ maxWidth: 520, margin: '48px auto', padding: '24px 28px', background: 'var(--surface)', borderRadius: 14,
        boxShadow: 'var(--shadow-sm)', textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--navy-900)', marginBottom: 8 }}>
          {update ? 'The portal was updated' : 'This screen could not be shown'}
        </div>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: '0 0 18px' }}>
          {update ? 'Reload the page to get the new version.' : 'Reload the page. If it happens again, tell Kate what you clicked.'}
        </p>
        <button type="button" onClick={() => window.location.reload()}
          style={{ padding: '9px 18px', borderRadius: 10, border: 'none', background: 'var(--navy-900)', color: '#fff',
            fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
          Reload
        </button>
      </div>
    )
  }
}
